import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { librarySettingsAPI } from '@/providers/apis/library/library';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'library-visibility',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class LibraryVisibility extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop()
    private value: any;

    @Prop()
    private isReadOnly: any;

    private updatedValues: any = {};

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    private libComponent: any = {
        is_global_visible: {
            name: 'Global visibility',
            parentKey: null,
            keyName: 'is_global_visible',
            required: {},
            items: [],
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
        hide_student_library_view: {
            name: 'Hide student library view',
            parentKey: null,
            keyName: 'hide_student_library_view',
            required: {},
            items: [],
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
        hide_gooru_catalog: {
            name: 'Hide gooru catalog',
            parentKey: null,
            keyName: 'hide_gooru_catalog',
            required: {},
            items: [],
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
        other_library_ids: {
            name: 'Other library id',
            parentKey: null,
            keyName: 'other_library_ids',
            required: {},
            items: [],
            fieldType: 'b-form-select',
            options: {
                'text-field': 'name',
                'value-field': 'id',
                'options': [],
            },
        },
    };

    private content: any = {};
    // ---------------------------------------------------------------------
    // Methods

    private created() {
        this.content = this.value;
        if (this.isReadOnly) {
            // getLibrarySettingsAsArray
        }
        librarySettingsAPI.fetchLibraryItemList().then((data: any) => {
            this.libComponent.other_library_ids.options.options = data;
        });
        this.setPreDefinedValues();
    }

    private onChangeConfig(item: any) {
        this.$emit('input', this.updatedValues);
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

    private setPreDefinedValues() {
        for (const key in this.content) {
            if (Object.prototype.hasOwnProperty.call(this.content, key)) {
                const element = this.content[key];
                this.updatedValues[key] = element;
                // this.libComponent[key]
            }
        }
    }
}

